import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client

import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";

import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add Neighbor
const GQLAddSavedhomes = gql`
  mutation createSavedhomes(
    $homeid: String
    $userId: String
    $address: String
    $savedDate: String
    $updatedDate: String
    $savedStatus: Int
    $neighborhoodId: String
  ) {
    createSavedhomes(
      homeid: $homeid
      userId: $userId
      address: $address
      savedDate: $savedDate
      updatedDate: $updatedDate
      savedStatus: $savedStatus
      neighborhoodId: $neighborhoodId
    ) {
      success
      message
    }
  }
`;

//Update Neighbor
const UpdateSavedhomes = gql`
  mutation updateneighbor($id: String, $name: String) {
    updateSavedhomes(id: $id, name: $name) {
      success
      message
    }
  }
`;

//Delete Neighbor
const deletesavedhomebyuser = gql`
  mutation deletesavedhomebyuser($homeid: String, $userId: String) {
    deletesavedhomebyuser(homeid: $homeid, userId: $userId) {
      success
      message
    }
  }
`;

//Get All Neighbor
const QUERY_getAllSavedHomelist = gql`
  query getsavedhome(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getsavedhome(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      id
      homeid
      userId
      address
      savedDate
      updatedDate
      savedStatus
      neighborhoodId
      ListingKeyNumeric
      BedroomsTotal
      BathroomsTotalInteger
      BathroomsFull
      BathroomsHalf
      City
      Country
      CountyOrParish
      Latitude
      Longitude
      ListAgentFullName
      ListAgentStateLicense
      ListAgentMLS
      ListPrice
      LivingArea
      ListOfficeName
      LotSizeArea
      LotSizeUnits
      ListingId
      Media
      MlsStatus
      ModificationTimestamp
      PostalCode
      PropertyType
      PropertySubType
      PostalCity
      PublicRemarks
      StandardStatus
      StateOrProvince
      SourceId
      ThumbnailUrl
      UnparsedAddress
      YearBuilt
      ClosePrice
    }
  }
`;
//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add Neighbor Function

async function addSavedhomes(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddSavedhomes,

        variables: {
          homeid: adddata.homeid,
          userId: adddata.userId,
          address: adddata.address,
          savedDate: adddata.savedDate,
          updatedDate: adddata.updatedDate,
          savedStatus: adddata.savedStatus,
          neighborhoodId: adddata.neighborhoodId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Update Function

async function updateSavedhomes(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: UpdateSavedhomes,

        variables: {
          id: updatedata.id,
          name: updatedata.name,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//Delete Function

async function deleteSavedhomes(deletedataId) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: deletesavedhomebyuser,
        variables: {
          homeid: deletedataId.homeid,
          userId: deletedataId.userId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//Get list by own query
async function getAllSavedHomelist(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_getAllSavedHomelist,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export {
  addSavedhomes,
  updateSavedhomes,
  deleteSavedhomes,
  getAllSavedHomelist,
};
